import React from 'react';
import Step1 from './Step1';
import Step2 from './Step2';


const Pages = ({ indexProgress = 0 }) => {
    const switchPage = [
        //  <Micrositioauto />,
        <Step1 />,
        <Step2 />,
    ]
    return (
        <div>
           
            <div className="">
                {switchPage[indexProgress]}
            </div>
        </div>
    );
}

export default Pages;
